<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                <div>
                    <h4 class="text-primary">Delivery</h4>
                    <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0);" @click="backParent">Invoice</a>
                    </li>
                    <li class="breadcrumb-item active">
                        <span v-if="delivery.id === null">New</span>
                        <span v-else>{{ delivery.deliver_no }}</span>
                    </li>
                    </ol>
                    <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                    <button v-if="delivery.id === null" type="button" @click="processAll" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-mail-forward" aria-hidden="true"></i> Process</button>
                    <button v-else type="button" @click="updateDelivery" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
                </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-body">
                <div class="row">
                    <!-- <strong class="font-24">Delivery</strong> -->
                    <div class="col-md-4">
                        <strong class="font-24">Delivery</strong>
                        <div class="form-group row">
                            <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                            <div class="col-sm-9">
                                <select v-model="delivery.type_id" class="form-control">
                                    <option v-for="t in deliveryTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="sale_date" class="col-sm-3 col-form-label text-left">Date</label>
                            <div class="col-sm-9">
                                <datetime v-model="delivery.deliver_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            </div>
                        </div>
                        <div class="form-group row">
                          <label for="sale_date" class="col-sm-3 col-form-label text-left">Delivery By</label>
                          <div class="col-sm-9">
                            <select class="form-control" v-model="delivery.employee_no" :disabled="sales.lock">
                                <option v-for="u in employeeList" :key="u.id" :value="u.employee_no">{{ u.employee_no }} - {{ u.name }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="notes" class="col-sm-3 col-form-label text-left">Notes</label>
                          <div class="col-sm-9">
                            <textarea class="form-control" rows="5" v-model="delivery.notes"/>
                          </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="float-left">
                        <address class="font-13">
                            <strong class="font-24">Sales</strong>
                            <br><b  class="font-16">{{ sales.sale_no }}</b>
                            <br>{{ sales.sale_date | dateFormat('DD/MM/YYYY')}}
                            <br>{{ sales.salesman }}
                            <br><b>{{ sales.taxes }}</b>
                            <br>{{ sales.price_list }}
                        </address>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="float-left">
                        <address class="font-13">
                            <strong class="font-24">Customer</strong>
                            <br><b>{{ sales.customer.name }}</b>
                            <br>{{ sales.customer.phone }}
                            <br><b>{{ sales.customer.address}}</b>
                        </address>
                        </div>
                    </div>
                </div>
                <hr class="mt-5 mb-5">
                <div class="row">
                    <div class="col-md-4">
                        <strong class="font-24">Product</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm">
                                <thead>
                                <th>Product</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Discount</th>
                                <th>Tax</th>
                                <th>Total</th>
                                </thead>
                                <tbody>
                                <tr v-for="d in sales.details" :key="d.id">
                                    <td><b>[{{ d.product_no }}]</b> {{ d.description }}</td>
                                    <td>{{ d.qty }}</td>
                                    <td>{{ d.price }}</td>
                                    <td>{{ d.discount | currency }}</td>
                                    <td>{{ d.tax | currency }}</td>
                                    <td>{{ d.total | currency }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Discount:</b></td>
                                    <td>{{ sales.discount }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Tax:</b></td>
                                    <td>{{ sales.tax }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total:</b></td>
                                    <td>{{ sales.total }}</td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <strong class="font-24">Delivery Detail:</strong>
                        <div class="table-responsive">
                            <table class="table table-item table-sm">
                                <thead>
                                    <th>Product No.</th>
                                    <th>Product</th>
                                    <th>Warehouse</th>
                                    <th>Qty</th>
                                    <th>Uom</th>
                                    <th>Serial Number</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, index) in delivery.details" :key="d.id">
                                        <td>
                                            <p class="input-group">
                                                <input type="text" class="form-control" v-model="d.product_no" disabled="disabled" />
                                                <span class="input-group-btn ml-1">
                                                    <button @click="setIdDetail(index)" data-toggle="modal" data-target="#modalDeliveryGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm"><i class="fa fa-search" aria-hidden="true"></i></button>
                                                </span>
                                            </p>
                                        </td>
                                        <td>{{ d.product }}</td>
                                        <td>{{ d.warehouse_no }}</td>
                                        <td>
                                            <input type="text" class="form-control" v-model="d.qty"/>
                                        </td>
                                        <td>{{ d.uom_id }}</td>
                                        <td>
                                            <input type="text" class="form-control" v-model="d.serial_number" :disabled="d.can_barcode !== true"/>
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span @click="addLine" class="link-secondary">+ Add Product</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- <pre>{{ delivery }}</pre> -->
            </div>
        </div>
        <SalesDeliveryModal @selectProduct="selectProduct" :sales="sales" :date="sales.sale_date"/>
    </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { deliveryUrl, getHeader, productUrl, salesUrl } from '../../config'
import SalesDeliveryModal from '@/components/sales/SalesDeliveryModal.vue'

export default {
  name: 'SaleDelivery',
  props: ['sales', 'delivery'],
  components: {
    SalesDeliveryModal
  },
  data () {
    return {
      idDetail: null
    }
  },
  computed: {
    ...mapState({
      deliveryTypeList: state => state.sales.deliveryTypeList,
      employeeList: state => state.employees.employeeList
    })
  },
  methods: {
    remove (index) {
      var dlv = this.delivery.details[index]
      if (dlv.id) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            Axios.delete(deliveryUrl + '/detail/' + dlv.id, { headers: getHeader() })
              .then(response => {
                this.delivery.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      } else {
        this.delivery.details.splice(index, 1)
      }
    },
    addLine () {
      var obj = {
        deliver_no: null,
        serial_number: null,
        sec_serial_number: null,
        qty: 1,
        product_no: null,
        product: null,
        warehouse_no: null,
        uom_id: null,
        queue: null,
        branch_no: null,
        company_no: null,
        can_barcode: false
      }
      this.delivery.details.push(obj)
    },
    selectProduct (value) {
      console.log(value)
      var detail = this.delivery.details.filter(d => d.id !== null)[this.idDetail]
      detail.deliver_no = this.delivery.deliver_no
      detail.serial_number = null
      detail.sec_serial_number = null
      detail.qty = 1
      detail.product_no = value.product_no
      detail.product = value.product_name
      detail.warehouse_no = value.warehouse_no
      detail.uom_id = value.uom_id
      detail.queue = null
      detail.branch_no = this.delivery.branch_no
      detail.company_no = this.delivery.company_no
      detail.can_barcode = value.canBarcode
    },
    setIdDetail: function (id) {
      this.idDetail = id
    },
    async updateDelivery () {
      await Axios.put(salesUrl + '/delivery/' + this.delivery.id, this.delivery, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    async processAll () {
      await this.createDelivery()
      // await this.setJournal()
      // await this.setCOGS()
    },
    async setCOGS () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(this.sales.sale_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'sales'
        }
        await Axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async setJournal () {
      await Axios.get(salesUrl + '/journal-stock-out/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async createDelivery () {
      await Axios.post(salesUrl + '/delivery', this.delivery, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  }
}
</script>
